// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes/dark.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes/light.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* BASE COLOR TOKENS */

  /* grey */
  --base-color-grey-white: #ffffff;
  --base-color-grey-0: #fafafa;
  --base-color-grey-10: #f2f2f2;
  --base-color-grey-20: #dedede;
  --base-color-grey-30: #c3c4c7;
  --base-color-grey-40: #aaaaad;
  --base-color-grey-50: #898a8f;
  --base-color-grey-70: #57585c;
  --base-color-grey-80: #404147;
  --base-color-grey-90: #313136;
  --base-color-grey-100: #1d1d21;
  --base-color-grey-black: #000000;

  /* grey alpha */
  --base-color-grey-10ba: #0000000a;
  --base-color-grey-20ba: #00000014;
  --base-color-grey-30ba: #00000029;
  --base-color-grey-40ba: #0000004d;
  --base-color-grey-50ba: #00000080;
  --base-color-grey-10wa: #ffffff0a;
  --base-color-grey-20wa: #ffffff14;
  --base-color-grey-30wa: #ffffff29;
  --base-color-grey-40wa: #ffffff4d;
  --base-color-grey-50wa: #ffffff80;
  --base-color-transparent: #ffffff00;

  /* azure */
  --base-color-azure-10: #e5f3fa;
  --base-color-azure-100: #062b3d;
  --base-color-azure-20: #b9def0;
  --base-color-azure-30: #8bcded;
  --base-color-azure-40: #65bbe5;
  --base-color-azure-50: #3ea5d9;
  --base-color-azure-60: #1b8ac2;
  --base-color-azure-70: #1572a1;
  --base-color-azure-80: #0c577d;
  --base-color-azure-90: #083e59;

  /* coral */
  --base-color-coral-10: #ffedea;
  --base-color-coral-100: #a2171d;
  --base-color-coral-20: #ffc9bf;
  --base-color-coral-30: #ffa496;
  --base-color-coral-40: #ff8474;
  --base-color-coral-50: #ff6f61;
  --base-color-coral-60: #e75a4f;
  --base-color-coral-70: #d2483f;
  --base-color-coral-80: #c03732;
  --base-color-coral-90: #b02727;

  /* crimson */
  --base-color-crimson-10: #fce7e7;
  --base-color-crimson-100: #4c0606;
  --base-color-crimson-20: #f4b8b8;
  --base-color-crimson-30: #f29b9b;
  --base-color-crimson-40: #eb7a7a;
  --base-color-crimson-50: #e05555;
  --base-color-crimson-60: #c23232;
  --base-color-crimson-70: #a81515;
  --base-color-crimson-80: #880b0b;
  --base-color-crimson-90: #6a100c;

  /* mint */
  --base-color-mint-10: #dffbf2;
  --base-color-mint-100: #072c20;
  --base-color-mint-20: #abeedd;
  --base-color-mint-30: #7cdebd;
  --base-color-mint-40: #4dc79f;
  --base-color-mint-50: #23ac7f;
  --base-color-mint-60: #1b8f68;
  --base-color-mint-70: #137252;
  --base-color-mint-80: #0e553d;
  --base-color-mint-90: #093a2a;

  /* gold */
  --base-color-gold-10: #f9ebcc;
  --base-color-gold-100: #392904;
  --base-color-gold-20: #f5da9d;
  --base-color-gold-30: #ebc56e;
  --base-color-gold-40: #e0b246;
  --base-color-gold-50: #ce9723;
  --base-color-gold-60: #ad7f13;
  --base-color-gold-70: #8c660b;
  --base-color-gold-80: #6c4e07;
  --base-color-gold-90: #523c09;

  /* ultramarine */
  --base-color-ultramarine-10: #eef1fe;
  --base-color-ultramarine-100: #0a1234;
  --base-color-ultramarine-20: #c4cffb;
  --base-color-ultramarine-30: #8da3f9;
  --base-color-ultramarine-40: #7790f7;
  --base-color-ultramarine-50: #5676f5;
  --base-color-ultramarine-60: #3858d9;
  --base-color-ultramarine-70: #2c47b1;
  --base-color-ultramarine-80: #182f88;
  --base-color-ultramarine-90: #1a2962;

  /* data sequential */
  --base-color-data-amber-1: #fff5ca;
  --base-color-data-amber-2: #ffe98a;
  --base-color-data-amber-3: #ffde49;
  --base-color-data-amber-4: #ffd209;
  --base-color-data-amber-5: #f7ba0d;
  --base-color-data-amber-6: #eea313;
  --base-color-data-amber-7: #e68b19;
  --base-color-data-amber-8: #dd731c;
  --base-color-data-cerulean-1: #bdeaf8;
  --base-color-data-cerulean-2: #98dcf2;
  --base-color-data-cerulean-3: #51c7e4;
  --base-color-data-cerulean-4: #06b1d7;
  --base-color-data-cerulean-5: #0793d1;
  --base-color-data-cerulean-6: #0876cc;
  --base-color-data-cerulean-7: #0759c7;
  --base-color-data-cerulean-8: #093bc1;

  /* data categorical */
  --base-color-data-apple-50: #c4dd71;
  --base-color-data-apple-60: #b4d447;
  --base-color-data-cobalt-50: #7a8f98;
  --base-color-data-cobalt-60: #455a64;
  --base-color-data-deep-orange-50: #eb5d30;
  --base-color-data-deep-orange-60: #e64a19;
  --base-color-data-deep-purple-50: #7e57c2;
  --base-color-data-deep-purple-60: #5e35b1;
  --base-color-data-green-50: #50ab79;
  --base-color-data-green-60: #3e8c61;
  --base-color-data-indigo-50: #9fa8da;
  --base-color-data-indigo-60: #7986cb;
  --base-color-data-lime-50: #9ee593;
  --base-color-data-lime-60: #8aec7b;
  --base-color-data-orange-50: #ffac32;
  --base-color-data-orange-60: #fb8c00;
  --base-color-data-peat-50: #997265;
  --base-color-data-peat-60: #73574a;
  --base-color-data-pink-50: #e16da5;
  --base-color-data-pink-60: #ce4c8a;
  --base-color-data-purple-50: #ad64c3;
  --base-color-data-purple-60: #8e34aa;
  --base-color-data-royal-50: #4390ee;
  --base-color-data-royal-60: #1976d2;
  --base-color-data-sanguine-50: #e55858;
  --base-color-data-sanguine-60: #c62828;
  --base-color-data-sky-50: #5ab5ff;
  --base-color-data-sky-60: #299efc;
  --base-color-data-teal-50: #60d6c2;
  --base-color-data-teal-60: #31bda5;
  --base-color-data-yellow-50: #f9de67;
  --base-color-data-yellow-60: #f2d03a;
}

/* Custom Classes */

.status-up-to-date {
  color: var(--colorContent-success);
  background-color: var(--colorBackground-success-muted);
}

.status-outdated {
  color: var(--colorContent-warning);
  background-color: var(--colorBackground-warning-muted);
}

.status-running {
  color: var(--colorContent-info);
  background-color: var(--colorBackground-info-muted);
}

.status-offline {
  color: var(--colorContent-critical);
  background-color: var(--colorBackground-critical-muted);
}

.status-new {
  color: var(--colorContent-accent);
  background-color: var(--colorBackground-accent-muted);
}
`, "",{"version":3,"sources":["webpack://./public/styles/color.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;;EAEtB,SAAS;EACT,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;;EAEhC,eAAe;EACf,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;;EAEnC,UAAU;EACV,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,UAAU;EACV,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;;EAEhC,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,oBAAoB;EACpB,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;;EAErC,qBAAqB;EACrB,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;EACtC,sCAAsC;EACtC,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,mBAAmB;;AAEnB;EACE,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;EACjC,qDAAqD;AACvD","sourcesContent":["@import url(themes/dark.css);\n@import url(themes/light.css);\n\n:root {\n  /* BASE COLOR TOKENS */\n\n  /* grey */\n  --base-color-grey-white: #ffffff;\n  --base-color-grey-0: #fafafa;\n  --base-color-grey-10: #f2f2f2;\n  --base-color-grey-20: #dedede;\n  --base-color-grey-30: #c3c4c7;\n  --base-color-grey-40: #aaaaad;\n  --base-color-grey-50: #898a8f;\n  --base-color-grey-70: #57585c;\n  --base-color-grey-80: #404147;\n  --base-color-grey-90: #313136;\n  --base-color-grey-100: #1d1d21;\n  --base-color-grey-black: #000000;\n\n  /* grey alpha */\n  --base-color-grey-10ba: #0000000a;\n  --base-color-grey-20ba: #00000014;\n  --base-color-grey-30ba: #00000029;\n  --base-color-grey-40ba: #0000004d;\n  --base-color-grey-50ba: #00000080;\n  --base-color-grey-10wa: #ffffff0a;\n  --base-color-grey-20wa: #ffffff14;\n  --base-color-grey-30wa: #ffffff29;\n  --base-color-grey-40wa: #ffffff4d;\n  --base-color-grey-50wa: #ffffff80;\n  --base-color-transparent: #ffffff00;\n\n  /* azure */\n  --base-color-azure-10: #e5f3fa;\n  --base-color-azure-100: #062b3d;\n  --base-color-azure-20: #b9def0;\n  --base-color-azure-30: #8bcded;\n  --base-color-azure-40: #65bbe5;\n  --base-color-azure-50: #3ea5d9;\n  --base-color-azure-60: #1b8ac2;\n  --base-color-azure-70: #1572a1;\n  --base-color-azure-80: #0c577d;\n  --base-color-azure-90: #083e59;\n\n  /* coral */\n  --base-color-coral-10: #ffedea;\n  --base-color-coral-100: #a2171d;\n  --base-color-coral-20: #ffc9bf;\n  --base-color-coral-30: #ffa496;\n  --base-color-coral-40: #ff8474;\n  --base-color-coral-50: #ff6f61;\n  --base-color-coral-60: #e75a4f;\n  --base-color-coral-70: #d2483f;\n  --base-color-coral-80: #c03732;\n  --base-color-coral-90: #b02727;\n\n  /* crimson */\n  --base-color-crimson-10: #fce7e7;\n  --base-color-crimson-100: #4c0606;\n  --base-color-crimson-20: #f4b8b8;\n  --base-color-crimson-30: #f29b9b;\n  --base-color-crimson-40: #eb7a7a;\n  --base-color-crimson-50: #e05555;\n  --base-color-crimson-60: #c23232;\n  --base-color-crimson-70: #a81515;\n  --base-color-crimson-80: #880b0b;\n  --base-color-crimson-90: #6a100c;\n\n  /* mint */\n  --base-color-mint-10: #dffbf2;\n  --base-color-mint-100: #072c20;\n  --base-color-mint-20: #abeedd;\n  --base-color-mint-30: #7cdebd;\n  --base-color-mint-40: #4dc79f;\n  --base-color-mint-50: #23ac7f;\n  --base-color-mint-60: #1b8f68;\n  --base-color-mint-70: #137252;\n  --base-color-mint-80: #0e553d;\n  --base-color-mint-90: #093a2a;\n\n  /* gold */\n  --base-color-gold-10: #f9ebcc;\n  --base-color-gold-100: #392904;\n  --base-color-gold-20: #f5da9d;\n  --base-color-gold-30: #ebc56e;\n  --base-color-gold-40: #e0b246;\n  --base-color-gold-50: #ce9723;\n  --base-color-gold-60: #ad7f13;\n  --base-color-gold-70: #8c660b;\n  --base-color-gold-80: #6c4e07;\n  --base-color-gold-90: #523c09;\n\n  /* ultramarine */\n  --base-color-ultramarine-10: #eef1fe;\n  --base-color-ultramarine-100: #0a1234;\n  --base-color-ultramarine-20: #c4cffb;\n  --base-color-ultramarine-30: #8da3f9;\n  --base-color-ultramarine-40: #7790f7;\n  --base-color-ultramarine-50: #5676f5;\n  --base-color-ultramarine-60: #3858d9;\n  --base-color-ultramarine-70: #2c47b1;\n  --base-color-ultramarine-80: #182f88;\n  --base-color-ultramarine-90: #1a2962;\n\n  /* data sequential */\n  --base-color-data-amber-1: #fff5ca;\n  --base-color-data-amber-2: #ffe98a;\n  --base-color-data-amber-3: #ffde49;\n  --base-color-data-amber-4: #ffd209;\n  --base-color-data-amber-5: #f7ba0d;\n  --base-color-data-amber-6: #eea313;\n  --base-color-data-amber-7: #e68b19;\n  --base-color-data-amber-8: #dd731c;\n  --base-color-data-cerulean-1: #bdeaf8;\n  --base-color-data-cerulean-2: #98dcf2;\n  --base-color-data-cerulean-3: #51c7e4;\n  --base-color-data-cerulean-4: #06b1d7;\n  --base-color-data-cerulean-5: #0793d1;\n  --base-color-data-cerulean-6: #0876cc;\n  --base-color-data-cerulean-7: #0759c7;\n  --base-color-data-cerulean-8: #093bc1;\n\n  /* data categorical */\n  --base-color-data-apple-50: #c4dd71;\n  --base-color-data-apple-60: #b4d447;\n  --base-color-data-cobalt-50: #7a8f98;\n  --base-color-data-cobalt-60: #455a64;\n  --base-color-data-deep-orange-50: #eb5d30;\n  --base-color-data-deep-orange-60: #e64a19;\n  --base-color-data-deep-purple-50: #7e57c2;\n  --base-color-data-deep-purple-60: #5e35b1;\n  --base-color-data-green-50: #50ab79;\n  --base-color-data-green-60: #3e8c61;\n  --base-color-data-indigo-50: #9fa8da;\n  --base-color-data-indigo-60: #7986cb;\n  --base-color-data-lime-50: #9ee593;\n  --base-color-data-lime-60: #8aec7b;\n  --base-color-data-orange-50: #ffac32;\n  --base-color-data-orange-60: #fb8c00;\n  --base-color-data-peat-50: #997265;\n  --base-color-data-peat-60: #73574a;\n  --base-color-data-pink-50: #e16da5;\n  --base-color-data-pink-60: #ce4c8a;\n  --base-color-data-purple-50: #ad64c3;\n  --base-color-data-purple-60: #8e34aa;\n  --base-color-data-royal-50: #4390ee;\n  --base-color-data-royal-60: #1976d2;\n  --base-color-data-sanguine-50: #e55858;\n  --base-color-data-sanguine-60: #c62828;\n  --base-color-data-sky-50: #5ab5ff;\n  --base-color-data-sky-60: #299efc;\n  --base-color-data-teal-50: #60d6c2;\n  --base-color-data-teal-60: #31bda5;\n  --base-color-data-yellow-50: #f9de67;\n  --base-color-data-yellow-60: #f2d03a;\n}\n\n/* Custom Classes */\n\n.status-up-to-date {\n  color: var(--colorContent-success);\n  background-color: var(--colorBackground-success-muted);\n}\n\n.status-outdated {\n  color: var(--colorContent-warning);\n  background-color: var(--colorBackground-warning-muted);\n}\n\n.status-running {\n  color: var(--colorContent-info);\n  background-color: var(--colorBackground-info-muted);\n}\n\n.status-offline {\n  color: var(--colorContent-critical);\n  background-color: var(--colorBackground-critical-muted);\n}\n\n.status-new {\n  color: var(--colorContent-accent);\n  background-color: var(--colorBackground-accent-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
